<template>
  <div class="wrapper" v-loading="isLoading">
    <h3 v-show="isTitleShow">{{ device.code }} - {{ device.name }} - {{ device.model }}</h3>
    <a-empty style="height: 100%;" v-if="warnings.length === 0" />
    <div class="cardsGroup" v-else>
      <el-card v-for="w in warnings" :key="w.id">
        <div slot="header" class="clearfix">
          <h3>
            {{ warningTypeMap[w.warningType][lang] }}
            <a-button type="link" @click="goToWarning(w)">{{ $t("modification.details") }}</a-button>
          </h3>
        </div>
        <p>{{ $t("SIM.company") + ": " + w.customer.company }}</p>
        <p>{{ $t("binding.serviceMan") + ": " + w.serviceNames }}</p>
        <p>{{ $t("warning.createdAt") + ": " + w.createdAt }}</p>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getDeviceWarningInfo } from "@/api/warning"
import { warningTypeMap } from "./warningTypes"

import moment from "moment"

export default {
  props: {
    device: {
      required: true,
      type: Object
    },
    showDetailMethod: {
      type: Function,
      default: null
    },
    isTitleShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isLoading: false,
      warnings: [],
      warningTypeMap
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    device() {
      this.renderWarningRemindList()
    }
  },
  mounted() {
    this.renderWarningRemindList()
  },
  methods: {
    async renderWarningRemindList() {
      this.isLoading = true
      try {
        const { data } = await getDeviceWarningInfo(this.device.id)
        const list = []
        let d, serviceNames
        for (let key in data) {
          if (data[key].length) {
            for (let i = 0; i < data[key].length; i++) {
              d = data[key][i]
              serviceNames = []
              if (d.serviceMans?.length) {
                for (let j = 0; j < d.serviceMans.length; j++) {
                  serviceNames.push(d.serviceMans[j].realName)
                }
              }
              d.serviceNames = serviceNames.join(", ")
              if (key === "maintain") {
                if (d.leaveDays <= 30) {
                  list.push({
                    ...d,
                    warningType: key,
                    createdAt: d.createdAt ? moment(d.createdAt).format("YYYY-MM-DD HH:mm:ss") : ""
                  })
                }
              } else {
                list.push({
                  ...d,
                  warningType: key,
                  createdAt: d.createdAt ? moment(d.createdAt).format("YYYY-MM-DD HH:mm:ss") : ""
                })
              }
            }
          }
        }
        this.warnings = list
      } catch(e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    goToWarning(w) {
      localStorage.setItem("deviceCode", w.device.code)
      localStorage.setItem("targetWarningType", warningTypeMap[w.warningType].code)
      if (this.showDetailMethod) {
        this.showDetailMethod(warningTypeMap[w.warningType].code)
        return
      }
      let routeUrl = this.$router.resolve({
        path: "/warning"
      })
      window.open(routeUrl.href, "_blank")
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  h3 {
    font-size: 18px;
    font-weight: normal;
    margin: 10px;
  }
  /deep/ .el-card {
    width: 23%;
    height: 46%;
    margin-bottom: 15px;
    .el-card__header {
      padding: 0;
    }
    &:nth-child(4n + 1) {
      margin-left: 1%;
    }
    &:nth-child(4n + 2),
    &:nth-child(4n + 3) {
      margin-left: 2%;
    }
    &:nth-child(4n + 3) {
      margin-right: 2%;
    }
  }
  .cardsGroup {
    width: 100%;
    height: calc(100% - 45px);
    overflow: auto;
    display: flex;
    padding-top: 5px;
    flex-wrap: wrap;
    h3 {
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
/deep/ .ant-empty-image {
  height: 65%;
}
</style>